import React, { useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";

function RequirementField({
  name,
  label,
  register,
  errors,
  setValue,
  getValues,
}) {
  const [requirement, setRequirement] = useState("");
  const [requirementList, setRequirementList] = useState([]);
  useEffect(() => {
    register(name, {
      required: true,
      validate: (value) => value.length > 0,
    });
  },[]);

  useEffect(() => {
    setValue(name, requirementList);
  }, [requirementList]);

  function handleAddRequirement() {
    if (requirement) {
      setRequirementList([...requirementList, requirement]);
      setRequirement("");
    }
  }

  const handleRemoveRequirement = (index) => {
    const updatedRequirementList = [...requirementList];
    updatedRequirementList.splice(index, 1);
    setRequirementList(updatedRequirementList);
  };


  return (
    <div className="mt-5 flex flex-col gap-y-2">
      <label htmlFor={label} className="text-richblack-50">
        {label} <sup className="text-pink-200">*</sup>
      </label>
      <div>
        <input
          type="text"
          name={name}
          id={name}
          value={requirement}
          onChange={(e) => setRequirement(e.target.value)}
          className="w-full bg-richblack-700 text-richblack-50 py-2 px-4 rounded-md border-b border-richblack-500"
        />
        <button onClick={handleAddRequirement} className="text-yellow-25  rounded-md mt-2">Add</button>
      </div>
      {requirementList.length > 0 && (
        <ul>
          {requirementList.map((requirement, index) => {
            return (
              <li key={index} className="flex w-full justify-between">
                <span className="text-lg text-richblack-100">{requirement}</span>
                <button type="button" onClick={()=>handleRemoveRequirement(index)} className="text-richblack-200 hover:text-yellow-25 transition-all duration-200"><AiFillDelete className="text-xl" /></button>
              </li>
            );
          })}
        </ul>
      )}
      {errors[name] && <span className="text-richblack-100">{label} is required</span>}
    </div>
  );
}

export default RequirementField;